import { POIList } from "@local-logic/elements-react";
import React from "react";
import { useMap } from "~/sdks/LocalContent/Map/MapGLMap/context";
import { useLocalContent } from "~/sdks/LocalContent/context";
import { useSchools } from "~/sdks/LocalContent/features/useSchools";

interface SchoolsProps {
  score: "primary_schools" | "high_schools";
}

const MapGLSchools = ({ score }: SchoolsProps) => {
  const { data } = useSchools();
  const { activePOI, setActivePOI, hoveredPOI, setHoveredPOI } =
    useLocalContent();
  const { mapRef, mapPadding } = useMap();

  if (!data) {
    return null;
  }

  return (
    <POIList.Root
      options={{
        type: "school",
        data: data?.[score],
        activePOI,
        hoveredPOI,
      }}
      onChange={(e) => {
        if (e.type === "poi-click") {
          const s = e.data;
          setActivePOI(s);

          const mapArea = window.innerWidth - mapPadding.left;
          const defaultMapCenter = window.innerWidth / 2;
          const xOffset = mapArea / 2 + mapPadding.left - defaultMapCenter;

          if (s) {
            mapRef.current?.easeTo({
              zoom: 18,
              center: [s.lng, s.lat],
              duration: 1000,
              offset: [xOffset, 0],
            });
          }
        }

        if (e.type === "poi-hover") {
          setHoveredPOI(e.data);
        }
      }}
    />
  );
};

export default MapGLSchools;
